<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 600px; max-width: 80vw;':''">
    <q-form @submit="onSubmit">
      <q-card-section v-if="selectedCustomer && selectedCustomer!==''" class="no-padding">
        <q-banner class="bg-blue text-white" inline-actions>
          ثبت گزارش برای : {{ selectedCustomer.Cs_Name }}
          <q-badge color="red" text-color="white" :label="selectedCustomer.Cs_Code" />
          <template v-slot:action>
            <q-btn icon="close" flat round v-close-popup/>
          </template>
        </q-banner>
      </q-card-section>
      <q-card-section class="q-gutter-xs">
        <q-select
            hide-bottom-space
            :dense="$q.screen.lt.md"
            v-model="logType"
            filled
            :options="visitLogTypeList"
            :rules="[selectRule]"
            label="نوع اعلان گزارش"
        />
        <q-input
            hide-bottom-space
            :dense="$q.screen.lt.md"
            filled
            type="textarea"
            v-model="timeLineComment"
            :rules="[ val => val && val.length > 0 || 'ثبت توضیحات الزامی می باشد']"
            label="توضیحات تکمیلی">
          <template v-slot:prepend>
            <q-icon name="comment"/>
          </template>
        </q-input>
        <q-select
            hide-bottom-space
            v-model="goodsGroup"
            label="گروه کالاها"
            :options="goodsGroupListOptions"
            option-label="Group_Name"
            option-value="Group_ID"
            use-chips
            use-input
            multiple
            filled
            @filter="goodsGroupFilter"
        />
        <q-toggle v-model="isSecretComment" label="گزارش محرمانه"/>
      </q-card-section>
      <q-card-section class="text-right">
        <q-btn icon="send" class="float-left" label="ارسال پیامک" color="indigo" @click="loadSMSPanel">
          <q-tooltip>
            ارسال پیامک
          </q-tooltip>
        </q-btn>
        <q-btn label="ثبت" type="submit"
               class="bg-indigo-6 text-white" icon="edit"/>
        <q-btn label="انصراف" flat class="q-ml-sm" icon="cancel" color="red" v-close-popup/>
      </q-card-section>
    </q-form>
    <q-dialog v-model="smsPanelDialog" :maximized="$q.screen.lt.md">
      <SMSPanel :is-dialog="true"
                :default-message="timeLineComment"
                :standalone="true"
                :with-customer-info="true"
                @close-dialog="smsPanelDialog=false"
                :receive-bu-current-user="true"
                :customer="selectedCustomer"/>
    </q-dialog>
  </q-card>
</template>
<script>
import {mapActions} from "vuex";
import SMSPanel from "@/components/callCenter/SMSPanel.vue";

export default {
  name: "CUVisitLog",
  components: {SMSPanel},
  props: ["selectedCustomer"],
  data() {
    return {
      smsPanelDialog: false,
      timeLineComment: '',
      logType: '',
      loc: '',
      goodsGroup: undefined,
      visitLogTypeList: this.$store.state.visitLogTypeList.map(item => item.title),
      goodsGroupList: [],
      goodsGroupListOptions: [],
      isSecretComment: false
    }
  },
  methods: {
    ...mapActions({
      SetCustomerVisitLog: 'Customers/setCustomerVisitLog',
      setGoodsGroup: 'Products/getSimpleGoodsGroupList'
    }),
    goodsGroupFilter(val, update) {
      if (val === '') {
        update(() => {
          this.goodsGroupListOptions = this.goodsGroupList
        })
        return
      }
      update(() => {
        this.goodsGroupListOptions = this.goodsGroupListOptions.filter(v => v.Group_Name.toLowerCase().indexOf(val) > -1)
      })
    },
    loadSMSPanel() {
      this.smsPanelDialog = true
    },
    selectRule(val) {
      if (val === null || val === '') {
        return 'انتخاب نوع گزارش الزامی است'
      }
    },
    getGroupsList() {
      this.setGoodsGroup().then((res) => {
        this.goodsGroupList = res
        this.goodsGroupListOptions = res
      })
    },
    async onSubmit() {
      let addObject = {
        comment: this.timeLineComment,
        logType: this.logType,
        Cs_ID: !this.selectedCustomer || this.selectedCustomer === '' ? null : this.selectedCustomer.Cs_ID,
        GroupsInfo: this.goodsGroup,
        IsSecret: this.isSecretComment,
        latitude: 0,
        longitude: 0,
        accuracy: 0
      }

      this.$getLocation({
        timeout: Infinity
      }).then((coordinate) => {
        addObject.latitude = coordinate.lat
        addObject.longitude = coordinate.lng
        addObject.accuracy = coordinate.accuracy
      })

      this.SetCustomerVisitLog(addObject).then((res) => {
        this.$q.notify({
          type: 'positive',
          color: 'positive',
          position: 'top',
          message: 'رویداد به ثبت رسید'
        })
        this.$emit('event-added', res.data)
      });
    },
  },
  created() {
    this.getGroupsList()
  }
}
</script>

<style scoped>

</style>
